import { useQuery, type UseQueryOptions, type UseQueryReturnType } from '@tanstack/vue-query'

interface PlayResponse {
  plays: any[]
  success: boolean
}

export function usePlayerPlays(
  playerId: string | number,
  params = {},
  options?: Omit<UseQueryOptions<PlayResponse, Error>, 'queryKey' | 'queryFn'>
): UseQueryReturnType<PlayResponse, Error> {
  return useQuery({
    queryKey: reactive(['player-plays', playerId, params]),
    queryFn: () => {
      const queryStringFromParams = Object.entries(toValue(params))
        .filter(([_, value]) => value !== null) // filter out null values     
        .map(([key, value]) => `${key}=${value}`) // map to query string
        .join('&'); // join with &
      return $fetch<PlayResponse>(
        `/api/plays/player/${playerId}?${queryStringFromParams}`,
        {
          method: 'GET',
        }
      );
    },
    ...options,
  })
}
